<template>
  <v-app>

    <router-view />
    <v-snackbar bottom right :value="updateExists" :timeout="0" color="primary">
      Nova versão disponível
      <v-btn text @click="refreshApp">
        Atualizar
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<style lang="scss">
  @import '@/styles/index.scss';
</style>

<script>
import { UpdateMixin } from "@/mixins";

export default {
  mixins: [ UpdateMixin ]
}
</script>
